import { render, staticRenderFns } from "./teamItem.vue?vue&type=template&id=01395b37&"
import script from "./teamItem.vue?vue&type=script&lang=js&"
export * from "./teamItem.vue?vue&type=script&lang=js&"
import style0 from "./teamItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports